export const pagesPlacesSettingsEn = {
  shared: {
    actionsColumn: {
      deleteButton: "Delete",
    },
    DeleteDialog: {
      title: "Delete {{name}}?",
      description:
        "If {{name}} is in use, it cannot be deleted. This action cannot be undone.",
      cancelButton: "Cancel",
      permanentlyDeleteButton: "Permanently Delete",
    },
  },
  placeSubCodeNames: {
    title: "Subcode Settings",
    description: "Manage place subcode names.",
    addPlaceSubCodeName: "Add Subcode Setting",
    editPlaceSubCodeName: "Edit {{name}}",
    searchPlaceholder: "Search by name",
    form: {
      name: {
        label: "Name",
        description: "Name must be unique within the organization.",
        placeholder: "Legacy Place Code",
      },
      displayOrder: {
        label: "Display Order",
        description: {
          forAdd: "If not specified, defaults to 0.",
        },
        placeholder: "1",
      },
    },
  },
};
